(function () {
  if (window.__broadcastCanadaCartDrawer) return;
  window.__broadcastCanadaCartDrawer = true;

  var RESERVE_KEY = 'canada_cart_reserve_until_v1';
  var EMPTY_KEY = 'canada_cart_was_empty_v1';
  var DURATION = 10 * 60 * 1000;
  var drawerObserver = null;
  var observedDrawer = null;

  function pad(number) {
    return number < 10 ? '0' + number : String(number);
  }

  function getDrawer() {
    return document.getElementById('cart-drawer');
  }

  function readItemCount(drawer) {
    var counter = drawer && drawer.querySelector('[data-cart-count]');
    if (!counter) return 0;

    var attribute = parseInt(counter.getAttribute('data-cart-count'), 10);
    if (!isNaN(attribute)) return attribute;

    var text = parseInt(counter.textContent, 10);
    return isNaN(text) ? 0 : text;
  }

  function startTimer() {
    var until = Date.now() + DURATION;

    try {
      sessionStorage.setItem(RESERVE_KEY, String(until));
      sessionStorage.setItem(EMPTY_KEY, '0');
    } catch (error) {}

    return until;
  }

  function syncTimerState() {
    var drawer = getDrawer();
    if (!drawer) return;

    var count = readItemCount(drawer);
    var banners = drawer.querySelectorAll('[data-cart-reserve-banner]');

    if (count <= 0) {
      banners.forEach(function (banner) {
        banner.hidden = true;
      });

      try {
        sessionStorage.removeItem(RESERVE_KEY);
        sessionStorage.setItem(EMPTY_KEY, '1');
      } catch (error) {}

      return;
    }

    banners.forEach(function (banner) {
      banner.hidden = false;
    });

    var until = 0;
    var wasEmpty = false;

    try {
      until = parseInt(sessionStorage.getItem(RESERVE_KEY), 10) || 0;
      wasEmpty = sessionStorage.getItem(EMPTY_KEY) === '1';
    } catch (error) {}

    if (wasEmpty || !until) {
      startTimer();
    } else {
      try {
        sessionStorage.setItem(EMPTY_KEY, '0');
      } catch (error) {}
    }
  }

  function drawTimer() {
    var drawer = getDrawer();
    if (!drawer) return;

    var count = readItemCount(drawer);
    if (count <= 0) return;

    var until = 0;

    try {
      until = parseInt(sessionStorage.getItem(RESERVE_KEY), 10) || 0;
    } catch (error) {}

    if (!until || until <= Date.now()) {
      until = startTimer();
    }

    var seconds = Math.max(0, Math.ceil((until - Date.now()) / 1000));
    var value = pad(Math.floor(seconds / 60)) + ':' + pad(seconds % 60);

    drawer.querySelectorAll('[data-cart-reserve-time]').forEach(function (element) {
      if (element.textContent !== value) {
        element.textContent = value;
      }
    });
  }

  function syncCheckoutTotal() {
    var drawer = getDrawer();
    if (!drawer) return;

    var source = drawer.querySelector('[data-cart-total]');
    var targets = drawer.querySelectorAll('[data-cart-checkout-total]');
    if (!source || !targets.length) return;

    var value = source.textContent.trim();

    targets.forEach(function (target) {
      if (target.textContent.trim() !== value) {
        target.textContent = value;
      }
    });
  }

  function render() {
    syncTimerState();
    drawTimer();
    syncCheckoutTotal();
  }

  function connect() {
    var drawer = getDrawer();
    if (!drawer) return;

    if (observedDrawer !== drawer) {
      if (drawerObserver) drawerObserver.disconnect();

      observedDrawer = drawer;
      drawerObserver = new MutationObserver(function () {
        render();
      });

      drawerObserver.observe(drawer, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['data-cart-count']
      });
    }

    render();
  }

  document.addEventListener('DOMContentLoaded', connect);
  document.addEventListener('shopify:section:load', connect);

  document.addEventListener('theme:cart:change', function () {
    window.setTimeout(connect, 0);
    window.setTimeout(connect, 150);
  });

  document.addEventListener('theme:cart:add', function () {
    window.setTimeout(connect, 150);
  });

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) connect();
  });

  window.setInterval(drawTimer, 250);

  if (document.readyState !== 'loading') {
    connect();
  }
})();
